export default "__VITE_ASSET__DXEY8aCi__"